import React, { PropTypes } from 'react';
import { isSafariBrowser } from '../../utils/dom';

const Card = ({ label, className, title, imageUrl, url }) => (
  <div className={`resource flex-item ${className}`}>
    <a
      style={isSafariBrowser ? { '-webkit-flex': '1 1 29em' } : null}
      className="resource-link-wrapper"
      href={url}
      rel="noopener noreferrer"
      target="_blank"
    >
      <div className="resource-label">
        <p>{label}</p>
      </div>
      <div className="resource-image">
        <img src={imageUrl} alt={title} />
      </div>
      <div className="resource-details">
        <h3 className="resource-title">{title}</h3>
        <span className="resource-link">Learn More </span>
      </div>
    </a>
  </div>
);

Card.propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
};

export default Card;



// WEBPACK FOOTER //
// ./src/pages/resources/components/Card/Card.js